import { useCallback, useState } from 'react'
import { useWidgetContext } from '../../context/WidgetContext'
import { CodeHtmlEditor, type CodeHtmlApplyPayload } from '../code/CodeHtmlEditor'

export const CodePanel = () => {
  const { agent, modeApi, emitOutput } = useWidgetContext()
  const { useEditCodeHtmlMutation } = modeApi as any
  const [editCodeHtml, { isLoading }] = useEditCodeHtmlMutation()
  const [html, setHtml] = useState('')

  const applyPrompt = useCallback(
    async ({ prompt, html: currentHtml, files }: CodeHtmlApplyPayload) => {
      if (!agent.id) {
        throw new Error('Agent is not ready.')
      }

      const response = await editCodeHtml({
        agentId: agent.id,
        prompt: prompt || 'Apply attached references to the current HTML.',
        html: currentHtml,
        files,
      }).unwrap()

      const nextHtml = String((response as any)?.html || '')
      if (!nextHtml.trim()) {
        throw new Error('Model returned empty HTML.')
      }

      setHtml(nextHtml)
      emitOutput({
        type: 'code',
        output: {
          html: nextHtml,
          prompt: prompt || '',
        },
      })
      return nextHtml
    },
    [agent.id, editCodeHtml, emitOutput]
  )

  return (
    <CodeHtmlEditor
      value={html}
      onChange={setHtml}
      onApply={applyPrompt}
      isApplying={isLoading}
      applyLabel="Apply Code"
      promptPlaceholder="Describe your HTML/code edit..."
      htmlPlaceholder="<p>Paste or write HTML here, then prompt changes.</p>"
    />
  )
}

export default CodePanel
